import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const YoungDriverExcess = (props) => {
  return (
    <FormGroup controlId="youngDriverExcess">
      <Col componentClass={ControlLabel} sm={5}>
        Young Driver Excess (HKD)
      </Col>
      <Col sm={7}>
          <FormControl
            type="text"
            autoComplete="off"
            maxLength="60"
            value={props.youngDriverExcess}
            onChange={props.handleChangeYoungDriverExcess}
          />
      </Col>
    </FormGroup>
  )
}

YoungDriverExcess.propTypes = {
  youngDriverExcess: PropTypes.string,
  handleChangeYoungDriverExcess: PropTypes.func
};

export default YoungDriverExcess;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/youngDriverExcess/YoungDriverExcess.js